(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molecule-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.mp');
    sections.forEach((root) => {
      // Gallery thumbnail swap
      const mainImg = root.querySelector('[data-mp-main-image]');
      root.querySelectorAll('[data-mp-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const full = thumb.getAttribute('data-full');
          if (full && mainImg) mainImg.src = full;
          root.querySelectorAll('[data-mp-thumb]').forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      // Quantity swatches -> update price + selected variant + purchase form
      const priceEl = root.querySelector('[data-mp-price]');
      const priceForEl = root.querySelector('[data-mp-price-for]');
      const variantInput = root.querySelector('[data-mp-variant-input]');
      // Rendered by the add-to-cart-button snippet, so match on the class.
      const addBtn = root.querySelector('button.mp__btn-cart');
      const buyBtn = root.querySelector('[data-mp-buynow]');
      const buyForm = root.querySelector('#mp-product-form');
      const swatches = root.querySelectorAll('[data-mp-swatch]');

      // Selection shared with the Bulk Inquiry form.
      const selected = {
        id: variantInput ? variantInput.value : '',
        title: root.querySelector('[data-mp-swatch].is-selected')?.getAttribute('data-variant-title') || '',
      };

      const selectSwatch = (btn) => {
        if (btn.hasAttribute('data-unavailable')) return;
        swatches.forEach((el) => {
          el.classList.remove('is-selected');
          el.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-checked', 'true');

        selected.id = btn.getAttribute('data-variant-id');
        selected.title = btn.getAttribute('data-variant-title') || '';

        if (variantInput) variantInput.value = selected.id;
        const price = btn.getAttribute('data-price');
        if (priceEl && price) priceEl.textContent = price;
        if (priceForEl) priceForEl.textContent = selected.title ? `for ${selected.title}` : '';
        if (addBtn) addBtn.disabled = false;
        if (buyBtn) buyBtn.disabled = false;
      };

      swatches.forEach((btn) => btn.addEventListener('click', () => selectSwatch(btn)));

      // Buy Now -> add the selected variant, then go to checkout.
      if (buyBtn && buyForm) {
        buyBtn.addEventListener('click', async () => {
          buyBtn.disabled = true;
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(buyForm),
            });
            if (res.ok) {
              window.location.href = '/checkout';
              return;
            }
          } catch (e) {
            /* fall through to a normal add-to-cart */
          }
          buyBtn.disabled = false;
          buyForm.submit();
        });
      }

      // Sync the current selection into the Bulk Inquiry form.
      const formQty = document.querySelector('[data-mp-form-qty]');
      const formType = document.querySelector('[data-mp-inquiry-type]');
      const formVariant = document.querySelector('[data-mp-form-variant]');
      root.querySelectorAll('[data-quote-open]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (formType) formType.value = 'Bulk Inquiry';
          if (formVariant) formVariant.value = selected.title || '';
          if (formQty && selected.title) formQty.value = selected.title;
        });
      });
    });

    // Remember which dialog was sent so the right one re-opens with its result:
    // the footer newsletter posts the same customer form as the certificate one.
    const FORM_KEY = 'mv_contact_form';
    const remember = (which) => {
      try {
        sessionStorage.setItem(FORM_KEY, which);
      } catch (e) {
        /* storage blocked: the inquiry dialog re-opens by default */
      }
    };
    document.querySelector('#mp-quote-form')?.addEventListener('submit', () => remember('quote'));

    // Certificate requests: a certification badge picks its certificate in the
    // dropdown, and the customer's tags follow the choice, e.g.
    // "certificate-request, certificate-kosher, certificate-kosher-nerolione".
    const certForm = document.querySelector('#mp-cert-form');
    const certSelect = certForm?.querySelector('[data-mp-cert-select]');
    const certTags = certForm?.querySelector('[data-mp-cert-tags]');
    const syncCertTags = () => {
      const tag = certSelect?.selectedOptions[0]?.dataset.tag;
      if (!certTags || !tag) return;
      certTags.value = ['certificate-request', tag, `${tag}-${certTags.dataset.productHandle}`].join(', ');
    };
    syncCertTags();
    certSelect?.addEventListener('change', syncCertTags);
    document.querySelectorAll('[data-cert-request]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (certSelect) certSelect.value = btn.dataset.certRequest;
        syncCertTags();
      });
    });
    certForm?.addEventListener('submit', () => {
      syncCertTags();
      remember('cert');
    });

    // Back from a post: re-open the dialog that was sent with its result. The
    // certificate result only belongs to this form if it was the one sent.
    let sentForm = null;
    try {
      sentForm = sessionStorage.getItem(FORM_KEY);
      sessionStorage.removeItem(FORM_KEY);
    } catch (e) {
      /* storage blocked: only the inquiry dialog can re-open */
    }
    const certResult = certForm?.querySelector('[data-mp-cert-result]');
    let reopen = null;
    if (sentForm === 'cert' && certResult) {
      reopen = '#cert-dialog';
    } else {
      certResult?.remove();
      if (window.location.search.includes('contact_posted=true')) reopen = '#quote-dialog';
    }
    if (reopen) {
      requestAnimationFrame(() => {
        document.querySelector(reopen)?.querySelector('dialog')?.showModal?.();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-similar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-psim]').forEach((root) => {
      const track = root.querySelector('[data-psim-track]');
      const prev = root.querySelector('[data-psim-prev]');
      const next = root.querySelector('[data-psim-next]');
      if (!track) return;

      const step = () => {
        const first = track.querySelector('.psim__item');
        const gap = parseInt(getComputedStyle(track).columnGap || '16', 10) || 16;
        const w = first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        return w * Math.max(1, Math.floor(track.clientWidth / w) - 1);
      };

      prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.style.opacity = track.scrollLeft <= 2 ? '0.4' : '1';
        if (next) next.style.opacity = track.scrollLeft >= max ? '0.4' : '1';
      };
      track.addEventListener('scroll', update, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
